import { AxiosGlobalFilters } from '../config';

function getEmpresaId() {
  const value = `; ${document.cookie}`;
  const parts = value.split('; companies=');
  if (parts.length !== 2) return undefined;
  try {
    return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()))?.id;
  } catch {
    return undefined;
  }
}

function headers() {
  const empresaId = getEmpresaId();
  return empresaId ? { EmpresaId: empresaId } : {};
}

export const EntradasService = {
  listar: ({ almoxarifadoId, ordemCompra, dataInicial, dataFinal, search, page = 1, pageSize = 10 } = {}) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/entradas-materiais',
      headers: headers(),
      params: {
        ...(almoxarifadoId && { almoxarifadoId }),
        ...(ordemCompra && { ordemCompra }),
        ...(dataInicial && { dataInicial }),
        ...(dataFinal && { dataFinal }),
        ...(search && { search }),
        page,
        pageSize,
      },
    }),

  listarComprasComSaldo: ({ almoxarifadoId } = {}) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/entradas-materiais/compras',
      headers: headers(),
      params: almoxarifadoId ? { almoxarifadoId } : undefined,
    }),

  criar: ({ ordemCompra, data, responsavelId, itens = [] }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: '/v1/entradas-materiais',
      headers: headers(),
      data: { ordemCompra, data, responsavelId, itens },
    }),

  excluir: ({ id }) =>
    AxiosGlobalFilters({ method: 'DELETE', url: `/v1/entradas-materiais/${id}`, headers: headers() }),

  // Itens
  listarItens: ({ id }) =>
    AxiosGlobalFilters({ method: 'GET', url: `/v1/entradas-materiais/${id}/itens`, headers: headers() }),

  adicionarItem: ({ id, materialId, quantidade, valorUnitario }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: `/v1/entradas-materiais/${id}/itens`,
      headers: headers(),
      data: { materialId, quantidade, valorUnitario },
    }),

  adicionarItensEmLote: ({ id, itens }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: `/v1/entradas-materiais/${id}/itens/lote`,
      headers: headers(),
      data: { itens },
    }),

  atualizarItem: ({ id, itemId, quantidade, valorUnitario }) =>
    AxiosGlobalFilters({
      method: 'PUT',
      url: `/v1/entradas-materiais/${id}/itens/${itemId}`,
      headers: headers(),
      data: { quantidade, valorUnitario },
    }),

  excluirItem: ({ id, itemId }) =>
    AxiosGlobalFilters({
      method: 'DELETE',
      url: `/v1/entradas-materiais/${id}/itens/${itemId}`,
      headers: headers(),
    }),
};
